import styled from "@emotion/styled";
import { tokens } from "@/shared/design-system/tokens";

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${tokens.spacing.md};
`;

export const MascotWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.sm};

  p {
    margin: 0;
    line-height: 1.5;
  }
`;
